import PeopleIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/PeopleIconPath";
import PersonIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/PersonIconPath";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import FixaSSRIcon from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import styles from "./PersonAndTeam.module.css";
import { FixaSkeleton } from "@coworker/apprestructured/src/shared/wrappers/FixaSkeleton/FixaSkeleton";
import { useMemo } from "react";
import { isLoading, Loading } from "../../loading";
import ModalColumn from "@coworker/apprestructured/src/task-management/components/ModalColumn/ModalColumn";

type PersonAndTeamProps = {
  title: string;
  user: string | null | Loading;
  team: string | Loading;
};

function PersonAndTeam({ title, user, team }: PersonAndTeamProps) {
  const content = useMemo(() => {
    if (isLoading(user) && isLoading(team)) {
      return <FixaSkeleton height="44px" />;
    } else if (user === null) {
      if (isLoading(team)) {
        return <FixaSkeleton height="20px" />;
      } else {
        return (
          <FixaText
            textStyle="Heading.S"
            className={styles["firstText"]!}
            data-testid="team-text"
          >
            {team}
          </FixaText>
        );
      }
    } else {
      return (
        <>
          {isLoading(user) ? (
            <FixaSkeleton height="20px" />
          ) : (
            <FixaText textStyle="Heading.S" className={styles["firstText"]!}>
              {user}
            </FixaText>
          )}
          {isLoading(team) ? (
            <FixaSkeleton height="24px" />
          ) : (
            <FixaText textStyle="Body.L">{team}</FixaText>
          )}
        </>
      );
    }
  }, [team, user]);

  return (
    <ModalColumn gap="small">
      <FixaText textStyle="Heading.S">{title}</FixaText>
      <div className={styles["wrapper"]}>
        <div className={styles["iconWrapper"]}>
          <FixaSSRIcon
            className={styles["icon"]!}
            paths={user ? PersonIconPath : PeopleIconPath}
          />
        </div>
        <div className={styles["textWrapper"]}>{content}</div>
      </div>
    </ModalColumn>
  );
}

export default PersonAndTeam;
